module.exports = __webpack_public_path__ + "static/img/changJingImg2.fe1dfe6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/changJingImg2.png
// module id = Xh7B
// module chunks = 2